import { Alert, styled } from "@mui/material";

const InputFieldError = styled(Alert)(({ theme }) => ({
  "border": "1px solid #F2B6A4",
  "marginTop": "0.5rem",
  "marginBottom": "0.7rem",
  "width": "102%",
  "padding": "0rem 0.7rem",
  "& .MuiAlert-message": {
    width: "100% !important",

  },
  "&.MuiAlert-standardError": {
    backgroundColor: theme.palette.error.light,
    color: "#262626",
  },
  "&.MuiAlert-standardError .MuiAlert-icon": {
    color: "#262626",
  },
}));

/**
 * sx for a FormHelperText wrapping InputFieldError outside GvTextField, so the
 * alert sits exactly as it does under GvTextField's own helper text.
 */
export const INPUT_FIELD_ERROR_HELPER_SX = {
  marginLeft: 0,
  marginBottom: "-0.625rem",
} as const;

export default InputFieldError;
